// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChartfieldList-module_chartfield_table_KwCuJ {
}

.ChartfieldList-module_chartfield_table_compact_RKr_A {
}

.ChartfieldList-module_chartfield_table_edit_mode_uBgs2 {
}

.ChartfieldList-module_right_icon_I7biF span {
  height: 100% !important;
  display: flex;
  align-items: center;
}

.ChartfieldList-module_table_header_cell_d7CFX {
}

.ChartfieldList-module_money_cell_IM4o6 {
}

td.ChartfieldList-module_total_label_cell_pfWqz {
  font-size: larger;
  text-align: right;
  padding-top: 10px;
  font-weight: 400;
}

.ChartfieldList-module_table_total_cell_YYKHF {
}

td.ChartfieldList-module_table_total_cell_YYKHF {
  padding-top: 10px;
  padding-right: 2px;
}

.ChartfieldList-module_trans_total_cell_euVHR {
}

td.ChartfieldList-module_trans_total_cell_euVHR {
  white-space: nowrap;
  text-align: left;
  padding-left: 2px;
}

.ChartfieldList-module_error_field_hf4US {
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/ChargeAllocations/ChartfieldList.module.css"],"names":[],"mappings":"AAAA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;AAEA","sourcesContent":[".chartfield_table {\n  composes: editable_table from 'Styles/styles.module.css';\n}\n\n.chartfield_table_compact {\n  composes: editable_table_compact from 'Styles/styles.module.css';\n}\n\n.chartfield_table_edit_mode {\n  composes: editable_table_edit_mode from 'Styles/styles.module.css';\n}\n\n.right_icon span {\n  height: 100% !important;\n  display: flex;\n  align-items: center;\n}\n\n.table_header_cell {\n  composes: table_header_cell from 'Styles/styles.module.css';\n}\n\n.money_cell {\n  composes: money_cell from 'Styles/styles.module.css';\n}\n\ntd.total_label_cell {\n  font-size: larger;\n  text-align: right;\n  padding-top: 10px;\n  font-weight: 400;\n}\n\n.table_total_cell {\n  composes: table_total_cell from 'Styles/styles.module.css';\n}\n\ntd.table_total_cell {\n  padding-top: 10px;\n  padding-right: 2px;\n}\n\n.trans_total_cell {\n  composes: table_total_cell;\n}\n\ntd.trans_total_cell {\n  white-space: nowrap;\n  text-align: left;\n  padding-left: 2px;\n}\n\n.error_field {\n  composes: error_field from 'Styles/colors.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartfield_table": `ChartfieldList-module_chartfield_table_KwCuJ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table"]}`,
	"chartfield_table_compact": `ChartfieldList-module_chartfield_table_compact_RKr_A ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table_compact"]}`,
	"chartfield_table_edit_mode": `ChartfieldList-module_chartfield_table_edit_mode_uBgs2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table_edit_mode"]}`,
	"right_icon": `ChartfieldList-module_right_icon_I7biF`,
	"table_header_cell": `ChartfieldList-module_table_header_cell_d7CFX ${___CSS_LOADER_ICSS_IMPORT_0___.locals["table_header_cell"]}`,
	"money_cell": `ChartfieldList-module_money_cell_IM4o6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["money_cell"]}`,
	"total_label_cell": `ChartfieldList-module_total_label_cell_pfWqz`,
	"table_total_cell": `ChartfieldList-module_table_total_cell_YYKHF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["table_total_cell"]}`,
	"trans_total_cell": `ChartfieldList-module_trans_total_cell_euVHR ChartfieldList-module_table_total_cell_YYKHF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["table_total_cell"]}`,
	"error_field": `ChartfieldList-module_error_field_hf4US ${___CSS_LOADER_ICSS_IMPORT_1___.locals["error_field"]}`
};
export default ___CSS_LOADER_EXPORT___;
